import { ConvexReactClient } from 'convex/react';

// New Convex backend client — replaces the Express API + Supabase auth stack
// for whatever's been wired over so far (see CONVEX_MIGRATION_STATUS.md).
// Most of frontend/src/ still talks to the old Express backend via
// services/api.ts + lib/supabase.ts; this client is used only by the pages
// and hooks that have been ported to Convex (currently: auth, cases).
const convexUrl = import.meta.env.VITE_CONVEX_URL as string | undefined;

if (!convexUrl) {
  // eslint-disable-next-line no-console
  console.error(
    'Missing VITE_CONVEX_URL environment variable. Convex-backed features (sign-in, cases) will fail.'
  );
}

// Fall back to an obviously-invalid placeholder (never a real deployment)
// so a missing env var degrades to "Convex calls fail" instead of crashing
// the constructor synchronously and blanking the whole app — same pattern
// lib/supabase.ts already uses for its anon key.
export const convex = new ConvexReactClient(convexUrl || 'https://missing-convex-url.convex.cloud');

export default convex;
